import React from 'react';
import { FaStar, FaRegStar } from 'react-icons/fa';

const FavoritesStar = ({ identificador, isUser, isFavorito, onToggle, style }) => {
  const handleClick = e => {
    e.stopPropagation();
    onToggle(identificador, isUser, !isFavorito);
  };

  return (
    <span
      onClick={handleClick}
      style={{
        cursor: 'pointer',
        color: isFavorito ? '#ffc107' : '#bbb',
        fontSize: '18px',
        lineHeight: 1,
        ...style,
      }}
      title={isFavorito ? 'Remover dos favoritos' : 'Adicionar aos favoritos'}
    >
      {isFavorito ? <FaStar /> : <FaRegStar />}
    </span>
  );
};

export default FavoritesStar;
